import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';

interface RevealProps {
  children: React.ReactNode;
  /** Stagger delay in seconds. */
  delay?: number;
  /** Distance (px) the element travels up as it reveals. */
  y?: number;
  className?: string;
  as?: 'div' | 'section' | 'li' | 'article';
}

/**
 * Lightweight scroll-reveal wrapper built on framer-motion (already in the project).
 * Fades + lifts content into view once, and respects reduced-motion preferences.
 */
export const Reveal: React.FC<RevealProps> = ({ children, delay = 0, y = 24, className, as = 'div' }) => {
  const reduceMotion = useReducedMotion();
  const MotionTag = motion[as];

  return (
    <MotionTag
      className={className}
      initial={reduceMotion ? { opacity: 0 } : { opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </MotionTag>
  );
};

export default Reveal;
